module.exports = __webpack_public_path__ + "static/quote@2x-69d790331aad119909460889318919ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/zinc/quote@2x.jpg
// module id = 444
// module chunks = 3627797113349 20562973939449 33019919093843